"use strict";

$(document).ready(function () {
  if ($(".gallery-section").length > 0) {
    var gallery_page = 2;
    var $iso_container = $('#gallery-grid');
    $iso_container.isotope({
      itemSelector: '.ms-grid',
      stamp: '.stamp'
    });
    $iso_container.imagesLoaded().progress(function () {
      $iso_container.isotope('layout');
    });
    var gal_count = gal_jason.length;
    $("body").on("click", ".gallery-section .load-more a", function (event) {
      var paged = parseInt($(this).attr('data-limit')) * gallery_page;
      var $newItems = "";
      var cur_items = $("#gallery-grid").children(".ms-grid").length;

      for (var i = cur_items; i < paged; i++) {
        if (gal_jason[i]) {
          $newItems += "<div class='ms-grid full_section' data-imgsize='" + $.trim(gal_jason[i]['img_size']) + "' data-tagurl='" + $.trim(gal_jason[i]['tag_url']) + "' data-title='" + $.trim(gal_jason[i]['img_title']) + "' data-subtitle='" + $.trim(gal_jason[i]['img_subtitle']) + "' data-tag='" + $.trim(gal_jason[i]['img_tag']) + "' data-url='" + $.trim(gal_jason[i]['url']) + "' data-weburl='" + $.trim(gal_jason[i]['web_url']) + "' data-desc='" + $.trim(encodeURI(gal_jason[i]['img_desc'])) + "'><img src='" + gal_jason[i]['img_url'] + "'  alt='" + $.trim(gal_jason[i]['img_title']) + "'></div>";

          if (cur_items + i == gal_count) {//return false;
          }
        } else {
          $(this).text("No more images");
          $(this).hide();
        }
      }

      $iso_container.isotope('insert', $($newItems));
      $iso_container.imagesLoaded().progress(function () {
        $iso_container.isotope('layout');
      }); //$iso_container.isotope('reloadItems');

      /*setTimeout(function(){
        $iso_container.isotope({
            itemSelector: '.ms-grid',
              stamp: '.stamp'
         });
      }, 500);*/

      gallery_page++;
      event.preventDefault();
    });
    $("body").on("click", ".remix-grid a", function (event) {
      event.preventDefault();
      $iso_container.isotope('shuffle');
    });
    $("body").on("click", ".gallery-section .full_section", function (event) {
      $(this).attr('data-top', $(this).offset().top);
      $(this).addClass('active');
      var $newItems = "";
      var full_img = $(this).children("img").attr('src');
      $newItems = "<img src='" + full_img + "'  alt='" + full_img + "'>";
      $newItems += "<div class='gallery_txt_box'>";
      $newItems += "<div class='gallery_title'>" + $(this).attr('data-title') + "</div>";
      $newItems += "<div class='gallery_subtitle'>" + $(this).attr('data-subtitle') + "</div>";
      $newItems += "<div class='gallery_tag_url'>";
      $newItems += "<div class='gallery_tag'><a href=" + $(this).attr('data-tagurl') + " target='_blank'>" + $(this).attr('data-tag') + "</a></div>";
      $newItems += "<div class='gallery_sign'>|</div>";
      $newItems += "<div class='gallery_url'><a href=" + $(this).attr('data-weburl') + " target='_blank'>" + $(this).attr('data-url') + "</a></div>";
      $newItems += "</div>";
      $newItems += "<div class='gallery_desc'>" + decodeURI($(this).attr('data-desc')) + "</div>";
      $newItems += "</div>";
      $('.full_width_gallery .add_content').html($newItems);
      $('.full_width_gallery').removeClass('Portrait');
      $('.full_width_gallery').removeClass('landscape');
      $('.full_width_gallery').addClass($(this).attr('data-imgsize'));
      $('.full_width_gallery').show();
      $('.gallery-gird').addClass('active');
      $iso_container.isotope('reloadItems').isotope({
        sortBy: 'original-order'
      });
      $("html, body").animate({
        scrollTop: 264
      }, "slow");
    });
    $("body").on("click", ".gallery-section .close_img", function (event) {
      $('.full_width_gallery').hide();
      $('.full_width_gallery').removeClass('Portrait');
      $('.full_width_gallery').removeClass('landscape');
      $('.gallery-gird').removeClass('active');
      $iso_container.isotope('reloadItems').isotope({
        sortBy: 'original-order'
      });
      setTimeout(function () {
        scroll_window();
      }, 300);
    });
  } // slider_width();
  // product_slider_arrow();
  // add_decimal();

});